import {FC, useState} from 'react'
import {Alert} from '../../../../../../_metronic/helpers/components/Alert'

type Props = {
  reasons: string[]
  /** Defaults to the invoice issue wording; pass the action name for other flows. */
  actionTitle?: string
}

const InvoiceIssueDisabledReason: FC<Props> = ({reasons, actionTitle = 'صدور صورتحساب'}) => {
  const [isOpen, setIsOpen] = useState(false)

  if (reasons.length === 0) {
    return null
  }

  return (
    <>
      <button
        type='button'
        className='btn btn-icon btn-light-info flex-shrink-0 ms-2'
        aria-label={`نمایش دلیل غیرفعال بودن ${actionTitle}`}
        aria-haspopup='dialog'
        title={`چرا ${actionTitle} غیرفعال است؟`}
        onClick={() => setIsOpen(true)}
      >
        <i className='las la-info-circle fs-2x' aria-hidden='true'></i>
      </button>

      {isOpen && (
        <Alert
          type='info'
          icon='la-info-circle'
          title={`دلیل غیرفعال بودن ${actionTitle}`}
          body={
            <div className='text-start'>
              <p>برای فعال شدن این دکمه، موارد زیر را تکمیل یا اصلاح کنید:</p>
              <ul className='mb-0'>
                {reasons.map((reason) => (
                  <li key={reason} className='mb-2'>
                    {reason}
                  </li>
                ))}
              </ul>
            </div>
          }
          cancel={{text: 'متوجه شدم', fn: () => setIsOpen(false)}}
          help={false}
        />
      )}
    </>
  )
}

export {InvoiceIssueDisabledReason}
